
<div class="card mb-3" id="models-container">
    <app-spinner [isLoading]="accreditationsContactsLoading"></app-spinner>
    <h5 class="card-header p-2">
        <span>{{'administration_customerContacts_label' | translate }}</span>
        <a id="triggerButton" [class.disabled]="!truDeliveryContactAdd" class="trigger grey pull-right search_button"
            mdbWavesEffect (click)="openAddClientContactsModal()" mdbTooltip="{{'administration_addContacts_label' | translate}}" placement="left">
            <mdb-icon fas icon="plus" class="text-muted"></mdb-icon>
        </a>
    </h5>
    <div class="card-body p-0">
        <div class="px-1">
            <div class="">
                <table width="100%;table-layout:fixed">
                    <tr *ngFor="let contact of accreditationContacts" height="44">
                        <td style="width:40px">
                            <div class="people_avatar-container">
                                <span class="people_avatar"><img id="user-avatar" ngxGravatar
                                        [email]='contact.contact?.emailAddress' [size]="21"
                                        [fallback]="'blank'" /></span>
                                <div class="people_fallbackInitial">{{ contact.contact?.emailAddress | limitTo:1 }}
                                </div>
                            </div>
                        </td>
                        <td style="padding:8px 2px;vertical-align:top;line-height:16px">
                            <span title="{{contact.contact?.emailAddress}}">{{contact.contact?.emailAddress}}</span>
                            <div *ngIf="contact.contact?.jobTitle==null" class="text-muted" style="font-size:86%">
                                {{'administration_contact_label' | translate}}</div>
                            <div class="text-muted" style="font-size:86%">{{contact?.contact?.jobTitle}}</div>
                        </td>
                        <td style="width:40px">
                            <span class="fa fa-paste cursorme"
                                [ngClass]="{'hidden':!contact.contact?.receivesProgressReports}"
                                mdbTooltip="{{contact.contact?.firstName}} {{contact.contact?.lastName}} {{'administration_receivesProgressReport_label' | translate }}"></span>
                        </td>
                        <td style="width:50px">
                            <div class="btn-group dropdown" dropdown>
                                <a mdbBtn floating="true" size="sm" class="grey lighten-2 waves-dark z-depth-0 m-0"
                                    mdbWavesEffect dropdownToggle>
                                    <mdb-icon fas icon="ellipsis-v" class="cursor-pointer text-muted"></mdb-icon>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right dropdown-primary"
                                    style="left:unset;right:10px;top:-10px;">
                                    <!-- <a class="dropdown-item" href="javascript:void(0)"
                                        (click)="openModifyClientContactsModal(contact)">{{  'BTN_modify_label' | translate }}</a> -->
                                    <a class="dropdown-item" href="javascript:void(0)"
                                        (click)="openDeleteClientContactConfirmModal(contact)">{{ 'BTN_delete_label' | translate }}</a>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Begin addClientContactsModal -->
<div mdbModal #addClientContactsModal="mdbModal" [config]="{backdrop: true, ignoreBackdropClick: true, keyboard: false}"
 class="modal fade left" id="addClientContactsModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-notify modal-info  modal-lg" role="document">
        <!--Content-->
        <div class="modal-content">
            <app-spinner [isLoading]="addClientContactsModalLoading"></app-spinner>
            <div class="modal-header">
                <h4 class="modal-title">{{'administration_addContacts_label' | translate }}</h4>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close"
                    (click)="checkIsModalDirty()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body mx-3">

                <mdb-accordion [multiple]="false">

                    <mdb-accordion-item [collapsed]="false">
                        <mdb-accordion-item-head>{{ 'administration_searchForContacts_label' | translate }}
                        </mdb-accordion-item-head>
                        <mdb-accordion-item-body (animationStateChange)="onToggleContactModalSection($event, 'serach-contacts')">
                            <table>
                                <tr>
                                    <td style="padding:0 2px">

                                        <div style="width:208px;height:38px">
                                            <div class="md-form input-group my-0">
                                                <input type="text" (ngModelChange)="resetPagnination(); isSearchSectionDirty=true"
                                                    class="form-control" name="searchName" autocomplete="off"
                                                    [(ngModel)]="searchName"
                                                    placeholder="{{ 'administration_contactsLastName_label' | translate }}"
                                                    style="width:155px;position:absolute;left:0">
                                                <div class="input-group-append" (click)="getAvailableContacts()"
                                                    mdbTooltip="{{ 'BTN_search_label' | translate }}" placement="right">
                                                    <span class=""><i class="fa fa-search"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                </tr>
                            </table>
                            <div style="margin-top:15px;height:400px;overflow:auto">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>&nbsp;</th>
                                            <th>{{ 'administration_name_label' | translate }}</th>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngFor="let contact of availableContacts | paginate : pageInfo">
                                            <td style="padding-left:5px">
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input"
                                                        id="{{contact?.id}}" [(ngModel)]="contact.isSelected" (ngModelChange)="isSearchSectionDirty=true">
                                                    <label class="form-check-label"
                                                        for="{{contact?.id}}"></label>
                                                </div>
                                            </td>
                                            <td width="31">
                                                <div class="people_avatar-container">
                                                    <span class="people_avatar">
                                                        <img id="user-avatar"
                                                            src='//s.gravatar.com/avatar/{{contact.contact?.emailAddress}}?s=21&amp;d=blank' />
                                                    </span>
                                                    <div class="people_fallbackInitial">
                                                        {{ contact?.name | limitTo:1 }}</div>
                                                </div>
                                            </td>
                                            <td>{{contact?.name}}</td>
                                        </tr>
                                        <tr *ngIf="!availableContacts.length">
                                            {{ 'administration_noResult_label' | translate }}</tr>
                                    </tbody>
                                </table>
                                <div *ngIf="!pageInfo.disablePagination">
                                    <pagination-template #p="paginationApi" [id]="pageInfo.id"
                                        (pageChange)="paginationChange($event)">
                                        <nav aria-label="Page navigation example">
                                            <ul class="pagination pg-blue-grey justify-content-center  pagination-sm">
                                                <li class="page-item " [class.disabled]="p.isFirstPage()">
                                                    <a (click)="p.previous()" class="page-link" tabindex="-1"
                                                        mdbWavesEffect>
                                                        <</a>
                                                </li>
                                                <ng-container *ngFor="let page of p.pages">
                                                    <li class="page-item"
                                                        [class.active]="p.getCurrent() === page.value">
                                                        <a (click)="p.setCurrent(page.value)"
                                                            *ngIf="p.getCurrent() !== page.value" class="page-link"
                                                            mdbWavesEffect>{{ page.label }}</a>
                                                    </li>

                                                    <li class="page-item" [class.active]="p.getCurrent() === page.value"
                                                        *ngIf="p.getCurrent() === page.value">
                                                        <a class="page-link" mdbWavesEffect>{{ page.label }}</a>
                                                    </li>
                                                </ng-container>
                                                <li class="page-item" [class.disabled]="p.isLastPage()">
                                                    <a (click)="p.next()" class="page-link" mdbWavesEffect>></a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </pagination-template>
                                </div>
                            </div>
                            <div class="p-2 text-right">
                                <button mdbBtn type="button" size="sm" class="waves-light unique-color-dark text-white"
                                    mdbWavesEffect
                                    (click)="checkIsModalDirty()">{{ 'BTN_cancel_label' | translate }}</button>
                                <button mdbBtn type="button" size="sm" class="waves-light primary-color-dark text-white"
                                    mdbWavesEffect (click)="saveSelectedContacts()"
                                    [disabled]="isExist()">{{ 'BTN_save_label' | translate }}</button>
                            </div>
                        </mdb-accordion-item-body>
                    </mdb-accordion-item>

                    <mdb-accordion-item>
                        <mdb-accordion-item-head>{{'administration_addNewContact_label' | translate}}
                        </mdb-accordion-item-head>
                        <mdb-accordion-item-body (animationStateChange)="onToggleContactModalSection($event, 'new-contact')">
                            <form class="form-horizontal" #addClientContactsModalForm="ngForm" role="form" name="modelForm">
                                <div class="d-grid" [ngClass]="{'has-error':(error.emailAddress)}">
                                    <div class="md-form">
                                        <input mdbInput type="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                                            class="form-control input-md" [(ngModel)]="clientDetails.emailAddress"
                                            name="add-contact-emailAddress" id="add-contact-emailAddress" placeholder=""
                                            required="required">
                                        <label for="add-contact-emailAddress" class=""> <span class="requiredField">*
                                            </span>{{ 'administration_emailAddress_label' | translate }}</label>
                                        <span class="text-danger"
                                            *ngIf="error?.emailAddress">{{error?.emailAddress?.errorMessage}}</span>
                                    </div>
                                </div>

                                <div class="d-grid" [ngClass]="{'has-error':(error.firstName)}">
                                    <div class="md-form">
                                        <input mdbInput type="text" class="form-control input-md"
                                            [(ngModel)]="clientDetails.firstName" name="add-contact-firstname"
                                            id="add-contact-firstname" placeholder="" required="required">
                                        <label for="add-contact-firstname" class=""><span class="requiredField">*
                                            </span>{{ 'administration_firstName_label' | translate }}</label>
                                        <span class="text-danger"
                                            *ngIf="error?.firstname">{{error?.firstname?.errorMessage}}</span>
                                    </div>
                                </div>

                                <div class="d-grid" [ngClass]="{'has-error':(error.prefixName)}">
                                <div class="md-form mb-22">
                                    <input type="text" name="lastName" autocomplete="off"
                                        id="prefixName-contact" class="form-control validate"
                                        [(ngModel)]="clientDetails.prefixName" mdbInput>
                                    <label for="prefixName-contact" class="">
                                        <span class="requiredField">*
                                        </span>{{ 'administration_prefixName_label' | translate }}
                                    </label>
                                    <mdb-error *ngIf="error?.prefixName">{{error?.prefixName?.errorMessage}}
                                    </mdb-error>
                                </div>
                                </div>

                                <div class="d-grid" [ngClass]="{'has-error':(error.lastName)}">
                                    <div class="md-form">
                                        <input mdbInput type="text" class="form-control input-md"
                                            [(ngModel)]="clientDetails.lastName" name="add-contact-lastname"
                                            id="add-contact-lastname" placeholder="" required="required">
                                        <label for="add-contact-lastname" class=""><span class="requiredField">*
                                            </span>{{ 'administration_lastName_label' | translate }}</label>
                                        <span class="text-danger"
                                            *ngIf="error?.lastName">{{error?.lastName?.errorMessage}}</span>
                                    </div>
                                </div>


                                <div class="d-grid">
                                    <div class="md-form">
                                        <input mdbInput type="text" class="form-control input-md"
                                            [(ngModel)]="clientDetails.jobTitle" name="add-contact-jobTitle"
                                            id="add-contact-jobTitle" placeholder="">
                                        <label for="add-contact-jobTitle"
                                            class="">{{ 'administration_jobTitle_label' | translate }}</label>
                                    </div>
                                </div>


                                <div>
                                    <ng-select name="genderType" id="genderType"
                                        [items]="genderTypes" bindLabel="name" placeholder="* Gender Type"
                                        [(ngModel)]="clientDetails.contactGenderType"
                                        (open)="genderTypes = [];getGenderTypes()"
                                        [loading]="genderTypesLoading">
                                    </ng-select>
                                </div>

                                <div class="p-2 text-right">
                                    <button mdbBtn type="button" size="sm"
                                        class="waves-light unique-color-dark text-white" mdbWavesEffect
                                        (click)="checkIsModalDirty()">{{ 'BTN_cancel_label' | translate }}</button>
                                    <button mdbBtn type="button" size="sm"
                                        class="waves-light primary-color-dark text-white" mdbWavesEffect
                                        (click)="addClientContact()"
                                        [disabled]="!addClientContactsModalForm.valid">{{ 'BTN_save_label' | translate }}</button>
                                </div>
                            </form>
                        </mdb-accordion-item-body>
                    </mdb-accordion-item>
                </mdb-accordion>
            </div>
        </div>
        <!--/.Content-->
    </div>
</div>
<!-- End addClientContactsModal -->

<!-- Begin modifyClientContactsModal -->
<div mdbModal #modifyClientContactsModal="mdbModal" class="modal fade left" id="modifyClientContactsModal" tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-notify modal-info" role="document">
        <!--Content-->
        <div class="modal-content">
            <app-spinner [isLoading]="modifyClientContactsModalLoading"></app-spinner>
            <div class="modal-header">
                <h4 class="modal-title">{{'administration_ModifyContact_label' | translate }}</h4>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close"
                    (click)="modifyClientContactsModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body mx-3">
                <form class="form-horizontal" role="form" name="modelForm">
                    <div class="form-group" [ngClass]="{'has-error':(error.emailAddress)}">
                        <label for="modify-contact-emailAddress" class="">
                            <span class="requiredField">*
                            </span>{{ 'administration_emailAddress_label' | translate }}</label>
                        <div class="">
                            <div class="md-form mt-0">
                                <input type="text" class="form-control" [(ngModel)]="clientDetails.contact.emailAddress"
                                    name="modify-contact-emailAddress" id="modify-contact-emailAddress" placeholder=""
                                    required="required">
                            </div>
                            <span class="text-danger"
                                *ngIf="error?.emailAddress">{{error?.emailAddress?.errorMessage}}</span>
                        </div>
                    </div>

                    <div class="form-group" [ngClass]="{'has-error':(error.firstName)}">
                        <label for="modify-contact-firstname" class="">
                            <span class="requiredField">*
                            </span>{{ 'administration_firstName_label' | translate }}</label>
                        <div class="">
                            <div class="md-form mt-0">
                                <input type="text" class="form-control" [(ngModel)]="clientDetails.contact.firstName"
                                    name="modify-contact-firstname" id="modify-contact-firstname" placeholder=""
                                    required="required">
                            </div>
                            <span class="text-danger" *ngIf="error?.firstname">{{error?.firstname?.errorMessage}}</span>
                        </div>
                    </div>

                    <div class="form-group" [ngClass]="{'has-error':(error.lastName)}">
                        <label for="modify-contact-lastname" class="">
                            <span class="requiredField">*
                            </span>{{ 'administration_lastName_label' | translate }}</label>
                        <div class="">
                            <div class="md-form mt-0">
                                <input type="text" class="form-control" [(ngModel)]="clientDetails.contact.lastName"
                                    name="modify-contact-lastname" id="modify-contact-lastname" placeholder=""
                                    required="required">
                            </div>
                            <span class="text-danger" *ngIf="error?.lastName">{{error?.lastName?.errorMessage}}</span>
                        </div>
                    </div>

                    <div class="d-grid" [ngClass]="{'has-error':(error.prefixName)}">
                        <div class="md-form mb-22">
                            <input type="text" name="lastName" autocomplete="off"
                                id="prefixName-contact" class="form-control validate"
                                [(ngModel)]="clientDetails.contact.prefixName" mdbInput>
                            <label for="prefixName-contact" class="">
                                <span class="requiredField">*
                                </span>{{ 'administration_prefixName_label' | translate }}
                            </label>
                            <mdb-error *ngIf="error?.prefixName">{{error?.prefixName?.errorMessage}}
                            </mdb-error>
                        </div>
                        </div>


                    <div class="form-group" [ngClass]="{'has-error':(error.jobTitle)}">
                        <label for="modify-contact-jobTitle"
                            class="">{{ 'administration_jobTitle_label' | translate }}</label>
                        <div class="">
                            <div class="md-form mt-0">
                                <input type="text" class="form-control" [(ngModel)]="clientDetails.contact.jobTitle"
                                    name="modify-contact-jobTitle" id="modify-contact-jobTitle" placeholder="">
                            </div>
                            <span class="text-danger" *ngIf="error?.jobTitle">{{error?.jobTitle?.errorMessage}}</span>
                        </div>
                    </div>

                    <div>
                        <ng-select name="genderType" id="genderType"
                            [items]="genderTypes" bindLabel="name" placeholder="* Gender Type"
                            [(ngModel)]="clientDetails.contactGenderType"
                            (open)="genderTypes = [];getGenderTypes()"
                            [loading]="genderTypesLoading">
                        </ng-select>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" mdbBtn size="sm" class="btn btn-default" data-dismiss="modal"
                    (click)="modifyClientContactsModal.hide()">{{'BTN_cancel_label' | translate }}</button>
                <button type="button" mdbBtn size="sm" class="btn btn-primary"
                    (click)='updateContact()'>{{'BTN_save_label' | translate }}</button>
            </div>
        </div>
        <!--/.Content-->
    </div>
</div>
<!-- End modifyClientContactsModal -->

<common-delete-modal (commonDelete)="confirmDelete($event)"></common-delete-modal>